import ExternalLink from 'components/common/ExternalLink'
import TestIds from 'util/TestIds'
import {
  TERMS_CONDITIONS_LINK,
  PRIVACY_POLICY_LINK,
  MAIN_SITE_BASE_URL,
  MAIN_SITE_BASE_URL_SHORT,
} from 'util/constants'

const EntryFooter = (): JSX.Element => {
  return (
    <div className="z-[3] flex h-auto w-full flex-col items-center justify-center gap-2 bg-neutral-100 p-4 md:h-[70px] md:flex-row md:gap-4 md:p-0">
      <ExternalLink
        className="text-link-primary typography-small font-medium"
        href={MAIN_SITE_BASE_URL}
        data-testid={TestIds.login.button.timelyMd}
      >
        {MAIN_SITE_BASE_URL_SHORT}
      </ExternalLink>
      <ExternalLink
        className="text-link-primary typography-small font-medium"
        href={TERMS_CONDITIONS_LINK}
        data-testid={TestIds.login.button.termsAndConditions}
      >
        Terms and Conditions
      </ExternalLink>
      <ExternalLink
        className="text-link-primary typography-small font-medium"
        href={PRIVACY_POLICY_LINK}
        data-testid={TestIds.login.button.privacyPolicy}
      >
        Privacy Policy
      </ExternalLink>
      <p className="typography-small font-bold text-neutral-500">
        Copyright © {new Date().getFullYear()} Timely Telehealth, LLC - 833.484.6359
      </p>
    </div>
  )
}

export default EntryFooter
